import { ApiResponse } from "../types";
import { SubcategoryAttributes } from "../types";
import { apiClient } from "./apiClient";

const BASE = "/subcategories";

function buildUrl(
  path: string,
  params?: Record<string, string | number>
): string {
  if (!params || Object.keys(params).length === 0) return path;
  const search = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => search.set(k, String(v)));
  return `${path}?${search.toString()}`;
}

export const subcategoriesApi = {
  async getAll(
    companyId?: number,
    categoryId?: number,
    type?: "input" | "output"
  ): Promise<ApiResponse<SubcategoryAttributes[]>> {
    try {
      const params: Record<string, string | number> = {};
      if (companyId != null) params.companyId = companyId;
      if (categoryId != null) params.categoryId = categoryId;
      if (type != null) params.type = type;
      const url = Object.keys(params).length > 0 ? buildUrl(BASE, params) : BASE;
      const data = await apiClient.get<any>(url);
      return {
        success: true,
        data: Array.isArray(data)
          ? data
          : (data?.data ?? data?.subcategories ?? []),
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  async getById(id: number): Promise<ApiResponse<SubcategoryAttributes>> {
    try {
      const data = await apiClient.get<any>(`${BASE}/${id}`);
      return {
        success: true,
        data: data?.data ?? data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  async create(
    payload: Omit<SubcategoryAttributes, "id" | "createdAt" | "updatedAt">
  ): Promise<ApiResponse<SubcategoryAttributes>> {
    try {
      const data = await apiClient.post<any>(BASE, payload);
      return {
        success: true,
        data: data?.data ?? data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  async update(
    id: number,
    payload: Partial<
      Omit<
        SubcategoryAttributes,
        "id" | "categoryId" | "companyId" | "createdAt" | "updatedAt"
      >
    >
  ): Promise<ApiResponse<SubcategoryAttributes>> {
    try {
      const data = await apiClient.put<any>(`${BASE}/${id}`, payload);
      return {
        success: true,
        data: data?.data ?? data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  async delete(id: number): Promise<ApiResponse<void>> {
    try {
      await apiClient.delete(`${BASE}/${id}`);
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },
};
